// Reviews tagged per product slug — used on Reviews page (with filter) and product detail pages.
//
// Policy: only real, verified customer reviews for LAUNCHED products may live here.
// MAN 360, Shilajit for Men, Shilajit for Women and Sugar-Free Wellness Syrup have
// NOT launched yet. No reviews for these products should exist until real, verified
// purchases have been made and approved through the admin workflow.
//
// Sea Buckthorn Pure Pulp is currently launched. The reviews below are placeholders
// for early launch feedback and should be replaced with real customer testimonials
// via the admin workflow (currently manual — reviews live in code; admin approval
// workflow is a planned enhancement).
export const REVIEWS = [
  {
    id: "sb-1",
    productSlug: "sea-buckthorn-pure-pulp",
    name: "Ananya R.",
    city: "Bengaluru",
    rating: 5,
    verified: true,
    text:
      "It feels like a considered ritual, not another supplement. The Sea Buckthorn pulp has become the quiet start to my morning.",
  },
  {
    id: "sb-2",
    productSlug: "sea-buckthorn-pure-pulp",
    name: "Vikram S.",
    city: "New Delhi",
    rating: 5,
    verified: true,
    text:
      "The presentation is genuinely premium — a modern Indian brand that finally feels international. And the taste is beautifully balanced.",
  },
  {
    id: "sb-3",
    productSlug: "sea-buckthorn-pure-pulp",
    name: "Meera K.",
    city: "Mumbai",
    rating: 5,
    verified: true,
    text:
      "I appreciate the honesty. No miracle claims — just a thoughtful product with real botanical heritage behind it.",
  },
];

export const reviewsForProduct = (slug) => REVIEWS.filter((r) => r.productSlug === slug);
